/*
 * motor-laden.js
 * ==============
 * Laadt de vaste gegevens van één motor voor de klikbare tekeningen en filtert
 * ze voor precies die motor. Gedeeld door de tekeningpagina (tekening.html) en
 * het tekeningenblok in de partscanner, zodat beide dezelfde regels volgen.
 * Merk-onafhankelijk: hetzelfde bestand staat in yamaha/ en mercury/.
 *
 *   laadMotor(basis, engineId) -> Promise<D | null>   (null = geen tekeningen voor deze motor)
 *   laadYamahaMotor             = laadMotor (oude naam)
 *
 * basis = adres van de merkmap (yamaha/, mercury/; eindigt op '/'). D heeft dezelfde
 * vorm als de motor.json van het eerste concept: titel, merk, motor, rubrieken,
 * tekeningen, weggelaten, winkel, scanner.
 */
(function () {
  "use strict";
  var DRAAI_LABELS = ["rechtsdraaiend", "linksdraaiend"];

  function json(url) {
    return fetch(url, { cache: "no-cache" }).then(function (r) {
      if (r.status === 404) return null;
      if (!r.ok) throw new Error("HTTP " + r.status + " " + url);
      return r.json();
    });
  }

  window.laadMotor = function (basis, engineId) {
    if (!engineId) return Promise.resolve(null);
    return Promise.all([json(basis + "instellingen.json"), json(basis + "motoren/" + encodeURIComponent(engineId) + ".json")])
      .then(function (res) {
        var inst = res[0], motor = res[1];
        if (!inst || !motor) return null;
        return json(basis + "catalogi/" + encodeURIComponent(motor.catalogus) + ".json").then(function (cat) {
          if (!cat) return null;
          // één map voor meer merken (BRP: Evinrude + Johnson): het motorbestand noemt dan zijn eigen merk
          var merk = motor.merk || inst.merk || "Yamaha";
          var platen = new URL(inst.platen, basis).href;
          var staart = motor.staart, draai = motor.draai;
          var tekeningen = [], weggelaten = [];
          cat.tekeningen.forEach(function (t) {
            // varianten voor een andere staartlengte of draairichting weglaten; is de
            // staartlengte niet zeker, dan blijven alle varianten met hun label staan
            var rijen = t.onderdelen.filter(function (r) {
              return !(r.staart && staart && r.staart !== staart) && !(r.draai && r.draai !== draai);
            }).map(function (r) {
              var uit = {
                // canon ontbreekt als hij gelijk is aan het nummer zonder streepjes/spaties (BRP, compacte vaste laag)
                ref: r.ref, nr: r.nr, canon: r.canon || String(r.nr).replace(/[-\s]/g, "").toUpperCase(),
                naam_oem: r.naam_oem, aantal: r.aantal,
                labels: (r.labels || []).filter(function (l) {
                  return !(staart && l.indexOf("alleen ") === 0) && DRAAI_LABELS.indexOf(l) === -1;
                }),
              };
              // Mercury: niet los leverbaar, door de fabrikant vervallen, opvolgers/sets uit de catalogus
              if (r.nss) uit.nss = true;
              if (r.vervallen) uit.vervallen = true;
              if (r.alt) uit.alt = r.alt;
              return uit;
            });
            if (!rijen.length) { weggelaten.push(t.naam); return; }
            var refs = {};
            rijen.forEach(function (r) { refs[r.ref] = 1; });
            tekeningen.push({
              fig: t.fig, naam: t.naam, naam_en: t.naam_en, rubriek: t.rubriek, illust: t.illust,
              breedte: null, hoogte: null,                       // uit de plaat zelf
              afbeelding: t.illust ? platen + t.illust + ".png" : null,
              miniatuur: t.illust ? platen + "klein_" + t.illust + ".png" : null,
              hotspots: t.hotspots.filter(function (h) { return refs[h.ref]; }),
              onderdelen: rijen,
              nummers: !!t.nummers,          // plaat zonder gedrukte positienummers: pagina zet ze erin
              lijst: !!t.lijst,              // groep zonder tekening (lege plaat): lijst met foto's
            });
          });
          if (!tekeningen.length) return null;
          var label = motor.naam + (motor.jaar ? " (" + motor.jaar + ")" : "");
          return {
            titel: merk + " " + label + " – onderdelen",
            merk: merk, namen: inst.namen || "scanner",
            motor: motor,
            rubrieken: inst.rubrieken.filter(function (r) { return tekeningen.some(function (t) { return t.rubriek === r; }); }),
            tekeningen: tekeningen, weggelaten: weggelaten, winkel: inst.winkel, scanner: inst.scanner,
          };
        });
      });
  };
  window.laadYamahaMotor = window.laadMotor;
})();
